import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Operation } from '../operation/operation';
import { DocumentService } from './document.service';
import { lookupParam } from '../nav/utils';

@Injectable()
export class DocumentResolver implements Resolve<Operation> {

  constructor(
    private router: Router,
    private documentService: DocumentService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Operation | Observable<Operation> | Promise<Operation> {
    return new Promise<Operation>(async (resolve, reject) => {
      
      let operation_id = lookupParam(route, 'operation_id');
      let revision_id = lookupParam(route, 'revision_id');
      let document_id = lookupParam(route, 'document_id');


      this.documentService
        .document(operation_id, revision_id, document_id)
        .subscribe((operation) => {
          if(operation) {
            return resolve(operation);
          }
          else {
            this.router.navigate(['operations', operation_id]);
            return resolve(null);
          }
        });
    });
  }
}